import { EnumConstantInterface, EnumOption } from '../../../../core/models/general.models';

export enum FundingTypeEnum {
    Conventional,
    ShariahCompliant,
}

export const FUNDING_TYPE_LABELS: EnumConstantInterface = {
    [FundingTypeEnum.Conventional]: { label: 'Interest', cssClass: '' },
    [FundingTypeEnum.ShariahCompliant]: { label: 'Profit', cssClass: '' },
};

export function getFundingTypeLabel(fundingType: FundingTypeEnum): EnumOption {
    const fundingTypeOption = FUNDING_TYPE_LABELS[fundingType];

    if (!fundingTypeOption) {
        return new EnumOption();
    }

    return fundingTypeOption;
}

export const FUNDING_TYPES_LABEL: EnumConstantInterface = {
    [FundingTypeEnum.Conventional]: { label: 'Conventional', cssClass: '' },
    [FundingTypeEnum.ShariahCompliant]: { label: 'Shariah-compliant', cssClass: '' },
};

export function getFundingTypesLabel(fundingType: FundingTypeEnum): EnumOption {
    const fundingTypeOption = FUNDING_TYPES_LABEL[fundingType];

    if (!fundingTypeOption) {
        return new EnumOption();
    }

    return fundingTypeOption;
}

export const WALLET_TYPE_LABELS: EnumConstantInterface = {
    [FundingTypeEnum.Conventional]: { label: 'Conventional', cssClass: '' },
    [FundingTypeEnum.ShariahCompliant]: { label: 'Islamic', cssClass: '' },
};

export function getWalletTypeLabel(walletType: FundingTypeEnum): EnumOption {
    const walletTypeOption = WALLET_TYPE_LABELS[walletType];

    if (!walletTypeOption) {
        return new EnumOption();
    }

    return walletTypeOption;
}

export const WALLET_TYPE_FILTER = [
    { id: FundingTypeEnum.Conventional, name: 'Conventional' },
    { id: FundingTypeEnum.ShariahCompliant, name: 'Islamic' },
];
